import React from 'react';
import { Frame } from './Frame';
import { ContactQuoteForm } from './ContactQuoteForm';
import { ContactBlueprint } from './ContactBlueprint';
import { GoogleRatingStrip } from './GoogleRatingStrip';
import { LogoMarquee } from './LogoMarquee';
export function Contact() {
  return <section id="contact" aria-labelledby="contact-title" className="scroll-mt-[72px] border-t border-line bg-white" data-id="element-93" data-mp="2w7qkxv0eet0f">
      <Frame className="overflow-hidden" data-id="element-94" data-mp="3sxzjve5ia0p8">
        <ContactBlueprint data-id="element-95" data-mp="3szu5kuolpwud" />
        <div className="relative flex flex-col items-center px-5 py-16 text-center md:px-6 md:py-24" data-id="element-96" data-mp="3ow4mululy9h9">
          <div className="mb-10 md:mb-12" data-id="element-97" data-mp="3k560p5mxuh63">
            <GoogleRatingStrip data-id="element-98" data-mp="3k44m4r6prcjm" />
          </div>
          <h2 id="contact-title" className="max-w-[760px] font-display text-[36px] font-semibold leading-[1.05] tracking-[-0.04em] text-ink md:text-[52px]" data-id="element-99" data-mp="3f6cln8s06i3t">
            Sie haben ein Bauteil, das gebaut werden soll?
          </h2>
          <p className="mt-5 max-w-[560px] text-[17px] leading-relaxed text-ink/75 md:text-[18px]" data-id="element-100" data-mp="bob9wojf0n8d">
            Schicken Sie eine Skizze, ein Foto oder eine kurze Beschreibung. Sie erhalten eine Rückmeldung mit Umfang
            und Preis – als Festpreis oder nach Aufwand.
          </p>
          <div className="mt-10 flex w-full justify-center" data-id="element-101" data-mp="3b2rgi9a1991q">
            <ContactQuoteForm data-id="element-102" data-mp="3f4cnjdzvyt40" />
          </div>
          <div className="mt-12 w-full md:mt-16" data-id="element-103" data-mp="3f31otslasbjr">
            <LogoMarquee reverse data-id="element-104" data-mp="314k320eyd94h" />
          </div>
        </div>
      </Frame>
    </section>;
}